import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonComponent',
  props: {
  label: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  show: {
    type: Boolean,
    default: true
  },
  saving: {
    type: Boolean,
    default: false
  }
},
  emits: ['clicked'],
  setup(__props, { emit: __emit }) {

const props = __props

const saving = ref<boolean>(props.saving)
const show = ref<boolean>(props.show)
const disabled = ref<boolean>(props.disabled)
const label = ref<string>(props.label)
const emit = __emit

function button_ClickedEvent(){
	emit('clicked')
}

watch(() => props.saving, (newValue: boolean) => {
  saving.value = newValue
})
watch(() => props.show, (newValue: boolean) => {
  show.value = newValue
})
watch(() => props.disabled, (newValue: boolean) => {
  disabled.value = newValue
})
watch(() => props.label, (newValue: string) => {
  label.value = newValue
})

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "submit",
        class: _normalizeClass(["flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary disabled:opacity-20", { 'opacity-20 pointer-events-none': disabled.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (button_ClickedEvent())),
        disabled: saving.value
      }, _toDisplayString(label.value), 11, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})